module.exports = __webpack_public_path__ + "media/images/plus-icon-1af0473323bc711341568048caa68656.png";